import BuilderModel from "~/models/tracked/builderModel";
import IRepo from "~/interfaces/repo";
import Repo from "~/state/modules/repo";
import ObjectModelTrigger from "~/models/objectModelTriggers/objectModelTrigger";
import Guid from "~/helpers/guid";
import Vue from "vue";
import {MultiPicklistUpdateMode} from "~/enums/multiPicklistUpdateMode";

export default class PropertyUpdate extends BuilderModel {
  property_client_id: string;
  value_to_update_to: any;
  value_to_update_to_formula: string;
  clear_value: boolean;
  //Handle for picklists
  values_to_update_to_array: Array<string> = [];
  is_multi_picklist: boolean;
  multi_picklist_mode: MultiPicklistUpdateMode;
  except = ['fieldName'];

  static repo: IRepo<PropertyUpdate> = new Repo<PropertyUpdate>('propertyUpdates', PropertyUpdate);

  constructor(parent:  ObjectModelTrigger, private fieldName: string, json: any = {}) {
    super();
    this.defineProperty('client_id', json['client_id'] || Guid.create());
    this.defineProperty('property_client_id', null);
    this.defineProperty('value_to_update_to', null);
    this.defineProperty('value_to_update_to_formula', null);
    this.defineProperty('values_to_update_to_array', []);
    this.defineProperty('clear_value', false);
    this.defineProperty('is_multi_picklist', false);
    this.defineProperty('multi_picklist_mode', MultiPicklistUpdateMode.Replace);

    this.fieldName = fieldName;
    this.parent = parent;
    this.rootModel = parent.rootModel;
    this.loadFromJson(json, this.rootModel);

    PropertyUpdate.repo.add(this);
    Vue.set(parent[fieldName], this.client_id , this);
  }

  get rootName(): string {
    return this.fieldName;
  }


}